import { Link } from 'react-router-dom';
import { BarChart3, ShieldCheck, Workflow } from 'lucide-react';
import Logo, { LogoMark } from '../ui/Logo';
import ThemeToggle from '../ui/ThemeToggle';

const FEATURES = [
  { icon: ShieldCheck, title: 'Enterprise Security', text: 'JWT-protected multi-tenant data with CAPTCHA verification.' },
  { icon: BarChart3, title: 'Real-time Analytics', text: 'Bookings, deliveries and payments at a glance.' },
  { icon: Workflow, title: 'Process Automation', text: 'GST invoices, serial numbers and reports on autopilot.' },
];

export default function AuthLayout({ children, title, tagline }) {
  return (
    <div className="flex min-h-screen bg-surface">
      {/* Marketing panel — fixed dark field, so it reads the same in both
          themes rather than inverting with the brand scale. */}
      <div
        className="relative hidden w-1/2 flex-col justify-between p-12 text-white lg:flex"
        style={{ backgroundColor: '#10616f' }}
      >
        <div className="flex items-center gap-3">
          <LogoMark size={38} />
          <span className="text-xl font-bold tracking-tight">Atelier ERP</span>
        </div>

        <div>
          <h1 className="text-3xl font-bold leading-tight tracking-tight">
            {title || 'Access Your Enterprise Resource Hub'}
          </h1>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-white/75">
            {tagline
              || 'The complete bespoke tailoring suite — measurements, orders, GST invoicing, payments and analytics in one place.'}
          </p>
          <div className="mt-9 space-y-5">
            {FEATURES.map((f) => (
              <div key={f.title} className="flex items-start gap-3.5">
                <span
                  className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
                  style={{ backgroundColor: 'rgba(255,255,255,0.12)' }}
                >
                  <f.icon size={17} strokeWidth={1.9} />
                </span>
                <div>
                  <p className="text-sm font-semibold">{f.title}</p>
                  <p className="mt-0.5 text-xs leading-relaxed text-white/70">{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="text-2xs text-white/50">© 2026 Atelier ERP · Tailored for bespoke fashion houses</p>
      </div>

      {/* Form panel */}
      <div className="relative flex w-full items-center justify-center p-6 lg:w-1/2">
        <div className="absolute right-4 top-4">
          <ThemeToggle />
        </div>
        <div className="w-full max-w-md">
          <Link to="/" className="mb-8 inline-flex lg:hidden">
            <Logo size={34} />
          </Link>
          {children}
        </div>
      </div>
    </div>
  );
}
